module.exports = __webpack_public_path__ + "static/img/berry-sparkle-sangria.be44806.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sang-pal/berry-sparkle-sangria.png
// module id = bfSm
// module chunks = 0